export default [
  {
    content: "안전인증 및 안전검사 수검 여부 확인",
    isChecked: "",
  },
  {
    content: "프레스 방호장치 부착 여부\n" +
      "(광전자식, 양수조작식, 게이트가드식 등)",
    isChecked: "",
  },
  {
    content: "금형조정 및 수리작업 시 안전블럭 설치 및 사용 여부",
    isChecked: "",
  },
  {
    content: "공압 프레스 금형교체 시 실린더 내부 압축공기 완전 제거 확인",
    isChecked: "",
  },
  {
    content: "동력차단장치(비상정치장치)설치 및 정상작동 여부",
    isChecked: "",
  },
  {
    content: "근로자 신체가 위험한계에 들어가지 않도록 해당 부위 덮개 설치 여부",
    isChecked: "",
  },
  {
    content: "상·하형 볼트 및 너트 체결상태 확인",
    isChecked: "",
  },
  {
    content: "압력능력, 회전각도계, 제원표 등 부착상태 확인",
    isChecked: "",
  },
  {
    content: "작업자 귀마개, 안전화 등 지급 및 착용 확인",
    isChecked: "",
  },
  {
    content: "조작판넬 각 스위치 명칭 표시 여부 확인",
    isChecked: "",
  },
  {
    content: "유압계통(배관, 호스등) 기름 누유 확인",
    isChecked: "",
  },
  {
    content: "접지선 연결 여부 확인",
    isChecked: "",
  },
  {
    content: "전원케이블 절연상태 확인",
    isChecked: "",
  },
];
